import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import language from '../../variables/language';
import Selector from '../../components/forms/Selector';
import '../../css/modals.css';

const emptyValues = () => ({planedStudentEventType:'', isCycled:'', dateTime:'', message:''});

export default function PlannedEventCreateModal({ isOpen, studentId, onClose, onCreated }) {
   const navigate = useNavigate();
   const [values, setValues] = useState(emptyValues());
   const [saving, setSaving] = useState(false);

   if(!isOpen) return '';

   const stopProp = e => e.stopPropagation();

   const handleFieldChange = (name, value) => {
      setValues(prev => ({...prev, [name]: value}));
   }

   const handleClose = () => {
      setValues(emptyValues());
      onClose();
   }

   const handleSubmit = (e) => {
      e.preventDefault();
      if(saving || !values.planedStudentEventType) return;
      const isCycled = values.isCycled === '1';
      setSaving(true);
      const payload = {
         student: String(studentId),
         planedStudentEventType: values.planedStudentEventType,
         isCycled: isCycled ? '1' : '2',
         isActive: '1',
      };
      if(!isCycled && values.dateTime) payload.dateTime = values.dateTime;
      if(values.message) payload.message = values.message;
      axios.post('/api/student/plannedevents', JSON.stringify(payload), {
         withCredentials: true,
         headers: { 'Content-Type': 'application/json' },
      }).then((response) => {
         setValues(emptyValues());
         onCreated(response.data && response.data.id, isCycled);
      }).catch(err => {
         if(err.response && err.response.status === 401){
            navigate('/login');
         }
         console.log(err);
      }).finally(() => {
         setSaving(false);
      });
   }

   const lang = language[language.lang];
   const isCycled = values.isCycled === '1';

   return (
      <div className="modal-update" onClick={handleClose} style={{ display: 'flex' }}>
         <div className="modal-window" onClick={stopProp}>
            <h3 className="modal-w-title">{lang['Plan some event']}</h3>
            <form onSubmit={handleSubmit}>
               <div className='student-lesson-create-fields'>
                  <div className='flex-from-input-wraper student-lesson-create-field-full' data-label={lang.planedStudentEventType}>
                     <Selector className='submit-field form-selection txt-c'
                        name='planedStudentEventType' url='/api/student/plannedevents/types'
                        value={values.planedStudentEventType} disabled={false}
                        selectorsHundler={(value) => handleFieldChange('planedStudentEventType', value)} />
                  </div>
                  <div className='flex-from-input-wraper student-lesson-create-field-full' data-label={lang.isCycled}>
                     <Selector className='submit-field form-selection txt-c'
                        name='isCycled' url='/api/booleans' value={values.isCycled} disabled={false}
                        selectorsHundler={(value) => handleFieldChange('isCycled', value)} />
                  </div>
                  {!isCycled ? (
                     <div className='flex-from-input-wraper student-lesson-create-field-full' data-label={lang.dateTime || lang.date}>
                        <input className='submit-field from-input txt-c' type='datetime-local'
                           value={values.dateTime} onChange={(e) => handleFieldChange('dateTime', e.target.value)} />
                     </div>
                  ) : ''}
                  <div className='flex-from-input-wraper student-lesson-create-field-full' data-label={lang.message}>
                     <textarea className='submit-field from-input txt-c event-edit-textarea'
                        placeholder={lang.message}
                        value={values.message} onChange={(e) => handleFieldChange('message', e.target.value)} />
                  </div>
               </div>
               <button type='submit' className='form-button txt-c' disabled={saving || !values.planedStudentEventType} style={{marginTop:14}}>
                  {saving ? lang['Loading ...'] : lang.save}
               </button>
            </form>
         </div>
      </div>
   );
}
